import dayjs from 'dayjs';
import { startCase } from 'lodash';
import {
  COMPONENT_DISPLAY_LITERALS_MAP,
  enabledComponentNames,
  excludeComponentsForBulkReplacement,
} from 'src/constants';
import {
  ComponentTypes,
  DyProductSource,
  IComponent,
  IComponentType,
  IStatus,
  LayoutTypes,
} from 'src/interfaces';

export const isComponentEnabled = (componentName: ComponentTypes): boolean => {
  return enabledComponentNames.includes(componentName);
};

export const getComponentDisplayName = (
  componentType?: ComponentTypes,
): string => {
  if (!componentType) return '';

  return (
    COMPONENT_DISPLAY_LITERALS_MAP[componentType] ||
    startCase(componentType.replace(/-/g, ' '))
  );
};

export const hideCODAndThankYouByLayoutType = (
  componentName: ComponentTypes,
  layoutTypeName: string | undefined,
): boolean => {
  return (
    (componentName === ComponentTypes.COD ||
      componentName === ComponentTypes.COD_THANK_YOU) &&
    layoutTypeName !== LayoutTypes.OUTDOOR
  );
};

export const showSoftSellComponent = (component: IComponent): boolean => {
  return !!(
    component.component_type?.name === ComponentTypes.PROMOTIONAL_SPACE &&
    component.start_date
  );
};

export const getReplacementComponentFilter = (
  componentDetails: IComponent,
  componentTypesPage?: IComponentType[],
  getParamsValue?: any,
): string => {
  let url = `width=${componentDetails?.width?.toString()}&height=${componentDetails?.height?.toString()}&status=${
    IStatus.READY
  }&layout_type_id=${componentDetails?.layout_type_id?.toString()}&id.notlist=${componentDetails?.id?.toString()}&same_products_source=true&end_date.from=${
    componentDetails.end_date ?? dayjs().add(1, 'day').format('YYYY-MM-DD')
  }&end_date.null=true`;

  const componetTypeIds =
    componentTypesPage
      ?.filter((item: IComponentType) =>
        excludeComponentsForBulkReplacement.includes(item.name),
      )
      ?.map((item: IComponentType) => item.id?.toString()) ?? [];

  const allowedIdsList =
    getParamsValue && getParamsValue('component_type_id.list');
  if (componetTypeIds?.length && !allowedIdsList?.length) {
    const componetTypeIdsFilters = `&component_type_id.notlist=${componetTypeIds.join(
      '|',
    )}`;

    url = `${url}${componetTypeIdsFilters}`;
  }

  return url;
};

export const normalizeComponentResponse = (
  response: any,
): IComponent | null => {
  if (!response) return null;
  if (Array.isArray(response)) {
    return response[0] || null;
  }

  return response;
};

export const isEligibleForSelection = (selectedCard?: IComponent | null) => {
  if (selectedCard?.status !== IStatus.READY) return false;

  const isNotCOD =
    selectedCard.component_type?.name !== ComponentTypes.COD &&
    selectedCard.component_type?.name !== ComponentTypes.COD_THANK_YOU;
  const isNotDynamicSource =
    selectedCard.config?.productsSource !== DyProductSource.DYS &&
    selectedCard.config?.productsSource !== DyProductSource.DYR;

  return isNotCOD && isNotDynamicSource;
};

export const getSelectableComponentTypes = (
  componentTypesPage: { data?: IComponentType[] },
  isReplacementMode: boolean,
) => {
  return (
    componentTypesPage?.data
      ?.filter((componentType) => {
        if (!isReplacementMode) return true;

        // Exclude COD & COD THANK YOU in replacement mode
        return !(
          componentType.name === ComponentTypes.COD ||
          componentType.name === ComponentTypes.COD_THANK_YOU
        );
      })
      .map((componentType) => ({
        value: componentType.id,
        label: getComponentDisplayName(componentType.name),
      })) ?? []
  );
};
